import { render } from "./README.md?vue&type=template&id=44a81bb5"
const script = {}
script.render = render

export default script